import { Injectable } from '@angular/core';

import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'Remuneration';
const ENDPOINT = `/remunerations/`;

const NAVIGATIONS: NavigationParam[] = [
    { key: 'account-entries', path: 'account-entries/', childClass: 'AccountEntryLine' },
    { key: 'potential-settlements', path: 'potential-settlements/', childClass: 'Settlement' },
    { key: 'settlements', path: 'settlements/', childClass: 'Settlement' },
];

const ROUTES: RouteParam[] = [
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'validate', path: '{id}/validate/' },
];

@Injectable({
    providedIn: 'root'
})
export class RemunerationService extends ServiceBase {

    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }
}
